module.exports = __webpack_public_path__ + "static/img/icon-alipay-full.78529443.png";